import EditScreenInfo from "../components/EditScreenInfo";
import { Text, View } from "../components/Themed";
import { RootTabScreenProps } from "../types";

import React from "react";
import {
  SafeAreaView,
  ScrollView,
  StyleSheet,
  useWindowDimensions,
} from "react-native";
import { Calendar } from "react-native-calendars";
import ComplianceCalendarList from "./ComplianceCalendarList";

function CustomCalendar(props) {
  const marked = {
    "2023-02-28": { marked: true },
    "2023-02-15": { marked: true },
    "2023-02-18": { selected: true },
  };
  return (
    <Calendar
      initialDate="2023-02-17"
      minDate="2022-12-01"
      maxDate="2024-01-30"
      markedDates={marked}
      disableAllTouchEventsForDisabledDays={true}
      {...props}
    />
  );
}

export default function ComplianceCalendarScreen({
  navigation,
}: RootTabScreenProps<"ComplianceCalendar">) {
  const { height, width, scale, fontScale } = useWindowDimensions();
  return (
    // <SafeAreaView style={styles.container}>
    <View style={styles.container}>
      <View style={styles.calendar}>
        <CustomCalendar
          onDayPress={(day) => console.log(`Date pressed: ${day.dateString}`)}
        />
      </View>
      <View></View>
      <View style={styles.calendar_events}>
        <ComplianceCalendarList />
      </View>
    </View>
    // </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-start",
  },
  calendar: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  calendar_events: {
    flex: 1,
    marginTop: 5,
    margin: 1,
    alignItems: "center",
    justifyContent: "center",
    // backgroundColor: "blue",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: "80%",
  },
});
